import { IConfirmableInjectedAction } from '../../../../interfaces';
import { catchError } from 'rxjs/operators';
import { get } from 'lodash';
import { of } from 'rxjs';

export class InjectedValidateMigration implements IConfirmableInjectedAction {
  performActionAfterConfirm = (bindObj, action) => {
    const rollbackId = get(action, 'rowData.migrationVariables.sourceTransactionUUID');
    const rowData = get(action, 'rowData');

    if (!rollbackId) {
      bindObj.worklist.notificationMessageService.error('Please choose valid rollback id');
      return;
    }

    bindObj.worklist.dataMigrationService.validateDataMigration(rowData)
      .subscribe(
        () => {
            this.refreshWorklist(bindObj, action, 'Migration validated');
            bindObj.worklist.notificationMessageService.success(`Migration validation successfully for rollbackId:  ${rollbackId}`);
        },
        catchError((err) => {
          console.error('Migration validation failed : Error : ', err.message);
          bindObj.worklist.notificationMessageService.error(`Migration validation Exception for rollbackId:   ${rollbackId}`);

          return of(err);
        })
      );
  }

  refreshWorklist = (bindObj, action, status) => {
    bindObj.worklist.refreshWorklist(
      bindObj.worklist,
      { status: status },
      null,
      action.rowData.meta,
      action.rowData.id
    );
  }
}
